<svg-icon
  src="/assets/images/svg/{{ icon }}.svg"
  [svgStyle]="{ 'width.px': width, 'height.px': height }"
></svg-icon>
